/*
 * 抽屉里的国家/语言选择器按需加载。
 * 国家列表有 200+ 项，内联进每个页面会多出几百 KB HTML，
 * 这里等抽屉真正被打开时才去取。
 */
(function () {
  const SELECTOR = '[data-localization-lazy]';

  function load(placeholder) {
    if (placeholder.dataset.loaded || placeholder.dataset.loading) return;
    const url = placeholder.dataset.sectionUrl;
    if (!url) return;

    placeholder.dataset.loading = 'true';
    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((html) => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const content = parsed.querySelector('.menu-drawer__localization');
        if (!content) return;
        placeholder.replaceChildren(content);
        placeholder.dataset.loaded = 'true';
      })
      .catch(() => {
        // 拉取失败就保持占位为空，不影响抽屉其他内容
      })
      .finally(() => {
        delete placeholder.dataset.loading;
      });
  }

  function loadAll() {
    document.querySelectorAll(SELECTOR).forEach(load);
  }

  function watch(details) {
    if (details.dataset.localizationWatched) return;
    details.dataset.localizationWatched = 'true';
    details.addEventListener('toggle', () => {
      if (details.open) loadAll();
    });
  }

  function init() {
    document.querySelectorAll('#Details-menu-drawer-container').forEach((details) => {
      watch(details);
      if (details.open) loadAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
